"use strict";

exports.__esModule = true;
exports["default"] = applyFixedBusinessManagerStylesToTheme;

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _theme = _interopRequireDefault(require("./theme.scss"));

var _businessManagerTheme = _interopRequireDefault(require("./business-manager-theme.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      & + & {\n        border-left-color: ", ";\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n        &:hover {\n          color: ", ";\n        }\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n        &:hover {\n          color: ", ";\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n          .", ":hover &,\n          .", ":active &,\n          .", " & {\n            color: ", ";\n          }\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n          &:hover svg {\n            fill: ", ";\n          }\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n          svg {\n            fill: ", ";\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        & {\n          & > div {\n            .", ":not(:only-child) {\n              .", " {\n                color: ", ";\n              }\n            }\n          }\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        .", ":hover &,\n        .", ":active &,\n        .", " & {\n          color: ", ";\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var colors = {
  divider: '#dfe5eb',
  primary: '#3899ec',
  controls: '#162d3d'
};

function applyFixedBusinessManagerStylesToTheme(_ref) {
  var theme = _ref.theme,
      css = _ref.css;
  var _theme$blogSharedValu = theme.blogSharedValues.classes,
      imageContainerClass = _theme$blogSharedValu.imageContainerClass,
      imageCaptionClass = _theme$blogSharedValu.imageCaptionClass,
      toolbarButtonWrapperClass = _theme$blogSharedValu.toolbarButtonWrapperClass,
      toolbarButtonActiveClass = _theme$blogSharedValu.toolbarButtonActiveClass;
  var linkHashtagColor = theme.blogSharedValues.colors.linkHashtagColor;
  var businessManagerToolbarTheme = {
    toolbar: _businessManagerTheme["default"].toolbar,
    toolbarButton_active: toolbarButtonActiveClass,
    toolbarSeparator: _businessManagerTheme["default"].toolbarSeparator,
    toolbarButton_wrapper: (0, _classnames["default"])(toolbarButtonWrapperClass, _theme["default"].toolbarButtonWrapper),
    toolbarButton_icon: (0, _classnames["default"])(_theme["default"].toolbarIcon, css(_templateObject(), toolbarButtonWrapperClass, toolbarButtonWrapperClass, toolbarButtonActiveClass, colors.primary))
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, theme), {}, {
    pluginContainer: (0, _classnames["default"])(_theme["default"].pluginContainer, _businessManagerTheme["default"].pluginContainer, css(_templateObject2(), imageContainerClass, imageCaptionClass, linkHashtagColor)),
    panelContainer: _businessManagerTheme["default"].panelContainer,
    hasFocus: _theme["default"].hasFocus
  }, (0, _utils.createToolbarTheme)('inline', businessManagerToolbarTheme)), (0, _utils.createToolbarTheme)('side', _objectSpread(_objectSpread({
    toolbar_floatingIcon: [css(_templateObject3(), colors.controls), css(_templateObject4(), colors.primary)]
  }, businessManagerToolbarTheme), {}, {
    toolbarButton_icon: (0, _classnames["default"])(_theme["default"].toolbarIcon, css(_templateObject5(), toolbarButtonWrapperClass, toolbarButtonWrapperClass, toolbarButtonActiveClass, colors.primary))
  }))), (0, _utils.createToolbarTheme)('plugin', businessManagerToolbarTheme)), {}, {
    inlineToolbarButton_active: _businessManagerTheme["default"].inlineToolbarButton_active,
    inlineToolbarDropdown_options: _businessManagerTheme["default"].inlineToolbarDropdown_options,
    inlineToolbarDropdownButton_icon: _businessManagerTheme["default"].inlineToolbarDropdownButton_icon,
    'Dropdown-menu': _businessManagerTheme["default"].dropdownMenu,
    'Dropdown-control': (0, _classnames["default"])(_businessManagerTheme["default"].dropdownControl, css(_templateObject6(), colors.primary)),
    'Dropdown-option': (0, _classnames["default"])(_businessManagerTheme["default"].dropdownOption, css(_templateObject7(), colors.primary)),
    tooltip: (0, _classnames["default"])(theme.tooltip, _businessManagerTheme["default"].toolbarTooltip),
    radioGroup: _businessManagerTheme["default"].radioGroup,
    radioGroupHorizontal_title: _businessManagerTheme["default"].label,
    radioGroup_input: (0, _classnames["default"])(_theme["default"].radioGroupInput, _businessManagerTheme["default"].radioGroupInput),
    radioGroup_button: (0, _classnames["default"])(_theme["default"].radioGroupButton, _businessManagerTheme["default"].radioGroupButton),
    slider: (0, _classnames["default"])(_theme["default"].slider, _businessManagerTheme["default"].slider),
    sliderWithInput_label: _businessManagerTheme["default"].label,
    sliderWithInput_input: _businessManagerTheme["default"].input,
    video_modal_container_big: _businessManagerTheme["default"].videoModalContainer,
    video_modal_add_a_Video: _businessManagerTheme["default"].addVideo,
    video_modal_header_text: _businessManagerTheme["default"].videoModalHeaderText,
    video_modal_or_upload_video_from: _businessManagerTheme["default"].orUploadVideoFrom,
    video_modal_upload_video: _businessManagerTheme["default"].orUploadVideo,
    video_modal_textInput_fullWidth: _businessManagerTheme["default"].videoModalInput,
    video_modal_textInput_customWidth: _businessManagerTheme["default"].videoModalInput,
    video_modal_add_button_inline: (0, _classnames["default"])(_businessManagerTheme["default"].button, _businessManagerTheme["default"].buttonPrimary),
    textInput_input: _businessManagerTheme["default"].input,
    textInput_input_invalid: _businessManagerTheme["default"].textInputInputInvalid,
    htmlEditPanel_primaryButton: _businessManagerTheme["default"].htmlToolbarPrimaryButton,
    htmlEditPanel_secondaryButton: _businessManagerTheme["default"].htmlEditPanel_secondaryButton,
    settingsPanel_footer: _businessManagerTheme["default"].settingsPanelFooter,
    imageSettingsTitle: _businessManagerTheme["default"].settingsTitle,
    imageSettingsSection: _businessManagerTheme["default"].imageSettingsSection,
    imageSettings_section: _businessManagerTheme["default"].galleryImageSettingsSection,
    galleryImageSettings_section: _businessManagerTheme["default"].galleryImageSettingsSection,
    gallerySettings_title: _businessManagerTheme["default"].settingsTitle,
    gallerySettings_divider: _businessManagerTheme["default"].settingsDivider,
    galleryImageSettings_title: _businessManagerTheme["default"].settingsTitle,
    galleryImageSettings_delete: _businessManagerTheme["default"].galleryImageSettingsDelete,
    galleryImageSettings_replace: _businessManagerTheme["default"].galleryImageSettingsReplace,
    galleryImageSettings_manageImageGrid: _businessManagerTheme["default"].galleryImageSettingsManageImageGrid,
    inputWithLabel_input: _businessManagerTheme["default"].input,
    inputWithLabel_textArea: _businessManagerTheme["default"].textarea,
    inputWithLabel_label: _businessManagerTheme["default"].label,
    checkbox_icon: _businessManagerTheme["default"].checkboxIcon,
    checkbox_icon_checked: _businessManagerTheme["default"].checkboxIconChecked,
    checkbox: _businessManagerTheme["default"].checkbox,
    imageRatioSelector_label: _businessManagerTheme["default"].label,
    imageRatioSelector_ratioButton: _businessManagerTheme["default"].imageRatioSelectorRatioButton,
    imageRatioSelector_ratioButton_selected: _businessManagerTheme["default"].imageRatioSelectorRatioButtonSelected,
    imageRatioSelector_ratioIcon: _businessManagerTheme["default"].imageRatioSelectorRatioIcon,
    imageRatioSelector_ratioIcon_selected: _businessManagerTheme["default"].imageRatioSelectorRatioIconSelected,
    imageRatioSelector_ratioLabel: _businessManagerTheme["default"].label,
    thumbnailPlacementSelector_label: _businessManagerTheme["default"].label,
    thumbnailPlacementSelector_icon: _businessManagerTheme["default"].thumbnailPlacementSelectorIcon,
    thumbnailPlacementSelector_icon_selected: _businessManagerTheme["default"].thumbnailPlacementSelectorIconSelected,
    layoutsSelector_label: _businessManagerTheme["default"].label,
    layoutsSelector_tile_label: _businessManagerTheme["default"].label,
    layoutsSelector_icon: _businessManagerTheme["default"].layoutsSelectorIcon,
    layoutsSelector_icon_selected: _businessManagerTheme["default"].layoutsSelectorIconSelected,
    tabs_headers_option_label: _businessManagerTheme["default"].tabsHeadersOptionLabel,
    tabs_headers_option: css(_templateObject8(), colors.divider),
    tabs_headers_option_selected: _businessManagerTheme["default"].tabsHeadersOptionSelected,
    itemContainer: _businessManagerTheme["default"].itemContainer,
    itemContainerSelected: _businessManagerTheme["default"].itemContainerSelected,
    filesItem: _businessManagerTheme["default"].filesItem,
    filesButton: _businessManagerTheme["default"].filesButton,
    topBarLink: _businessManagerTheme["default"].topBarLink,
    button_primary: (0, _classnames["default"])(_businessManagerTheme["default"].button, _businessManagerTheme["default"].buttonPrimary),
    button_secondary: (0, _classnames["default"])(_businessManagerTheme["default"].button, _businessManagerTheme["default"].buttonSecondary),
    linkPanel_textInput: _businessManagerTheme["default"].input,
    linkPanel_Input_textInput: _businessManagerTheme["default"].input,
    linkPanel_input_textInput: _businessManagerTheme["default"].input,
    linkPanel_TextInput: _businessManagerTheme["default"].input,
    linkPanel_dropdownList: _businessManagerTheme["default"].input,
    linkPanel_textInput_invalid: _businessManagerTheme["default"].input,
    linkPanel_errorIcon: _businessManagerTheme["default"].input,
    linkPanel_FooterButton: _businessManagerTheme["default"].linkPanelFooterButton,
    linkPanel_enabled: _businessManagerTheme["default"].linkPanelEnabled
  });
}